export default __webpack_public_path__ + "img/list-arrow.d074a393.svg";